import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloProviderHooks } from '@apollo/react-hooks'
import { ThemeProvider } from 'react-css-themr'
import { Provider } from 'react-redux'

import { PreviousAppStateManager } from 'utils/PreviousAppStateManager'
import { RestorePreviousPath } from 'utils/RestorePreviousPath'

import theme from 'styles/theme'

export default function AppProvider({ store, client, children }) {
  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <ApolloProviderHooks client={client}>
          <ThemeProvider theme={theme}>
            <PreviousAppStateManager>
              <RestorePreviousPath />
              {children}
            </PreviousAppStateManager>
          </ThemeProvider>
        </ApolloProviderHooks>
      </ApolloProvider>
    </Provider>
  )
}
